import { Trans } from "react-i18next";import { CalendarIcon } from "lucide-react";
import { cn } from "../../../lib/utils";

function formatDays(value) {
  const label = value === 1 ? "Day" : "Days";
  return `${value.toFixed(1)} ${label}`;
}

export function BalanceDurationBar({ duration, balanceError, overlapError }) {
  const showDuration = duration !== null;
  const durationHasError =
  duration === "Invalid Combination" || Boolean(overlapError);

  if (!showDuration && !balanceError && !overlapError) {
    return null;
  }

  return (
    <div className="space-y-1">
    {showDuration &&
      <div
        className={cn(
          "rounded-lg border px-3 py-2 font-sans",
          durationHasError ?
          "bg-[var(--color-error)]/10 border-[var(--color-error)]/20 text-[var(--color-error)]" :
          "bg-[var(--color-primary)]/5 border-[var(--color-primary)]/10 text-[var(--color-primary)]/80"
        )}>
        
        <div className="flex items-center gap-2">
  <div
            className={cn(
              "h-6 w-6 rounded-md grid place-items-center shrink-0",
              durationHasError ?
              "bg-[var(--color-error)]/15" :
              "bg-[var(--color-primary)]/10"
            )}>
            
    <CalendarIcon className="h-3 w-3" />
  </div>

  <span className="text-xs font-medium"><Trans i18nKey="dateTime.duration3" /></span>

  <span
            className={cn(
              "text-sm font-bold",
              durationHasError ?
              "text-[var(--color-error)]" :
              "text-[var(--color-primary)]"
            )}>
            
    {duration === "Invalid Combination" ?
            "Invalid Combination" :
            formatDays(duration)}
  </span>
</div>
      </div>
      }

    {balanceError &&
      <p className="text-xs font-medium text-[var(--color-error)]">
        {balanceError}
      </p>
      }

    {overlapError &&
      <p className="text-xs font-medium text-[var(--color-error)]">
        {overlapError}
      </p>
      }
  </div>);

}
